import React from 'react';
import { Box, Grid, GridList, GridListTile, Typography, useTheme } from '@material-ui/core';
import queryString from 'query-string';

import { ThreeDotsIcon } from 'ui/icons';
import { IconTile } from 'ui';
import { useLocale } from 'hooks/useLocale/useLocale';
import { UserRole } from 'context/user/userContext/UserContext.types';
import { CompanyIcon } from 'ui/icons/companyIcon/CompanyIcon';
import { getAccountTypes } from 'config/accountTypes';

import { useStyles } from './AccountType.styles';

export const AccountType = () => {
  const classes = useStyles();
  const theme = useTheme();
  const { formatMessage } = useLocale();
  const types = getAccountTypes(theme);

  const handleSelectRole = async (role: UserRole) => {
    const query = queryString.stringify({
      app: process.env.REACT_APP_ENROLMENT_APP,
      roleName: role,
      returnURL: encodeURIComponent(process.env.REACT_APP_RETURN_URL as string),
    });
    const url = `${process.env.REACT_APP_ENROLMENT_URL as string}?${query}`;
    window.location.replace(url);
  };

  return (
    <Grid container className={classes.container}>
      <Grid item xs={12} className={classes.header}>
        <Typography className={classes.title}>{formatMessage({ id: 'account_type.title' })}</Typography>
        <ThreeDotsIcon color="secondary" />
      </Grid>

      <GridList cols={2} cellHeight="auto" spacing={13}>
        {types.map(type => (
          <GridListTile key={type.label} cols={1}>
            <IconTile
              icon={type.icon}
              title={formatMessage({ id: type.label })}
              color={type.color}
              onClick={() => handleSelectRole(type.role)}
              iconFullSize
            />
          </GridListTile>
        ))}
      </GridList>

      <a href="https://www.energyweb.org/" className={classes.link}>
        <Box className={classes.footer}>
          <Typography className={classes.poweredBy}>{formatMessage({ id: 'common.powered_by' })}</Typography>
          <CompanyIcon className={classes.companyIcon} />
          <Typography className={classes.companyName}>{formatMessage({ id: 'common.company_name' })}</Typography>
        </Box>
      </a>
      <Box className={classes.version}>
        <Typography className={classes.poweredBy}>v{process.env.REACT_APP_VERSION}</Typography>
      </Box>
    </Grid>
  );
};
